module.exports = __webpack_public_path__ + "img/img03.aea95190.svg";